import { IdTutorialStep } from "../../IdTutorialStep";
export var checkTutorialStepIsClickBuyButton = function (path) { return function (action, state$, dependencies) {
    if (action.tutorialStep === IdTutorialStep.constructWindmill_clickBuyButton) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/checks/checkTutorialStepIsClickBuyButton.ts
// module id = 2471
// module chunks = 3